import React from 'react'
import styled from 'styled-components'
import Modal from 'react-modal'

import i18n from '../../i18n'
import LinkButton from '../../components/LinkButton'

interface Props {
  handleCloseModal: () => void
  modalIsOpen: boolean
  url: string
}

const CloseAppModal: React.FC<Props> = ({ handleCloseModal, modalIsOpen, url }) => (
  <StyledModal isOpen={modalIsOpen} closeTimeoutMS={1000}>
    <Container>
      <AlignCenter>
        <h1>{i18n.t('closeApp.title')}</h1>
        <p>{i18n.t('closeApp.text')}</p>

        <ButtonBar>
          <div>
            <LinkButton inverted to={url}>
              {i18n.t('closeApp.shutdown')}
            </LinkButton>
          </div>
          <div>
            <LinkButton transparent onClick={handleCloseModal}>
              {i18n.t('closeApp.continue')}
            </LinkButton>
          </div>
        </ButtonBar>
      </AlignCenter>
    </Container>
  </StyledModal>
)

Modal.setAppElement('body')

const StyledModal = styled(Modal)`
  background-color: ${({ theme }) => theme.blue};
  bottom: 0;
  left: 0;
  padding: 0;
  right: 0;
  top: 0;
  position: fixed;
  overflow-y: auto;
`

const AlignCenter = styled.div`
  color: white;
  max-width: 430px;
  text-align: center;

  & p {
    font-size: 1.125rem;
  }
`

const ButtonBar = styled.div`
  display: flex;
  margin-top: 40px;
  flex-wrap: wrap;

  & > div {
    flex-grow: 1;
    flex-basis: 0;
    margin: 0 5px 5px 5px;
  }
`

const Container = styled.div`
  color: white;
  display: flex;
  justify-content: center;
  padding: 0 20px;
  height: 100%;
  align-items: center;
`

export default CloseAppModal
